import { Alert } from "@flat-ui";
import { PlanCreationMode, SubjectType } from "@custom-types/base-types";
import { CREDITS_DISPLAY_NAME } from "@utils/limit-data-display";

interface Props {
  /** Which kind of product the user is about to add */
  creationMode: PlanCreationMode;

  /** The type of the subject the product is assigned to */
  subjectType: SubjectType;
}

/**
 * Explains what the page assigns, so that it is clear which products grant access to
 * Sphere XG or HoloBuilder and which ones only enhance an existing subscription.
 */
export function PlanCreationInfoAlert({
  creationMode,
  subjectType,
}: Props): React.JSX.Element | null {
  // Hardware licenses are neither subscriptions nor add-ons, so they get no alert
  if (creationMode === "hardware-license") {
    return null;
  }

  const subject = subjectType === "PROJECT" ? "project" : "workspace";

  const { title, description } =
    creationMode === "subscription"
      ? {
          title: "Paid subscriptions",
          description: `Here you can assign paid subscriptions to the ${subject}. All of these subscriptions (except ${CREDITS_DISPLAY_NAME}) give access to Sphere XG or HoloBuilder.`,
        }
      : {
          title: "Features and bundles",
          description: `Here you can assign individual features or bundles (collection of features) to the ${subject}. These features act as add-ons or enhancements for the ${subject} but none of them give access to Sphere XG or HoloBuilder. For access please assign one of the plans in the section "Add Subscription".`,
        };

  return (
    <Alert
      variant="info"
      title={title}
      description={description}
      sx={{ mb: 2.5 }}
    />
  );
}
